/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material';
import { FormButtons, PaymentForm, Spinner } from 'components/elements';
import { useReactHookFormErrorMap, useStripeActions } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function PaymentSettingsForm({ isEditableInitial, onSubmit, onCancel }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { updateCard } = useStripeActions();
  const [isEditable, setIsEditable] = useState(isEditableInitial);
  const [defaultStripeCard, setdefaultStripeCard] = useState(true);
  const [isLoading, setisLoading] = useState(false);
  const { handleSubmit, reset, getValues, setValue, setError, control } = useForm({
    mode: 'onSubmit',
    defaultValues: {},
  });

  setValue('defaultStripeCard', defaultStripeCard);
  const mapErrorToForm = useReactHookFormErrorMap(getValues, setError, '');
  const handleCheck = (status) => {
    setdefaultStripeCard(status);
    setValue('defaultStripeCard', status);
  };

  const handlerLoaderAndEdit = () => {
    setisLoading(true);
    setIsEditable(!isEditable);
  };

  return (
    <form
      className={classes.paymentUpdateForm}
      onSubmit={handleSubmit((data) => {
        updateCard(data)
          .then(() => {
            setIsEditable(false);
            onSubmit();
          })
          .catch((error) => mapErrorToForm(error));
      })}
    >
      <FormButtons
        isEditMode={isEditable}
        onReset={() => {
          reset({});
          onCancel();
        }}
        onModeUpdate={handlerLoaderAndEdit}
      >
        <div className={classes.payment}>
          {isLoading ? <Spinner /> : null}
          <Controller
            name="paymentInformation"
            control={control}
            rules={{
              validate: (value) => {
                if (value?.complete) {
                  return null;
                }
                return t('please_fill_in_this_field');
              },
            }}
            render={({ field: { ref, ...restField }, fieldState: { error } }) => (
              <PaymentForm classes={classes.paymentWrapper} error={!!error} helperText={error ? error.message : null} {...restField} required />
            )}
          />
          <Controller
            name="defaultStripeCard"
            control={control}
            rules={{
              validate: () => {
                if (defaultStripeCard) {
                  return null;
                }
                return t('please_select_default_card');
              },
            }}
            render={({ field: { ref, ...restField }, fieldState: { error } }) => (
              <div className={classes.parentCheckbox}>
                <FormControlLabel
                  checked={defaultStripeCard}
                  control={<Checkbox checked={defaultStripeCard} size="small" onChange={() => handleCheck(!defaultStripeCard)} name="defaultStripeCard" />}
                  label={<Typography className={classes.defaultCard}>{t('stripe_default_card')}</Typography>}
                  {...restField}
                />
                <FormHelperText className={classes.errorTextCard}>{error ? error.message : null}</FormHelperText>
              </div>
            )}
          />
        </div>
      </FormButtons>
    </form>
  );
}

PaymentSettingsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isEditableInitial: PropTypes.bool.isRequired,
};

PaymentSettingsForm.defaultProps = {};

export default PaymentSettingsForm;
